import React, { useContext, useEffect, useState,useRef } from "react";
import ModalMain from "../../../../components/Modal/ModalMain";
import ModalHeader from "../../../../components/Modal/ModalHeader";
import ExportCsvBody from "./ExportCsvBody";
import { useTranslation } from "react-i18next";
import ModalFooter from "../../../../components/Modal/ModalFooter";
import Moment from "moment";
import { useFormik } from "formik";
import studylistContext from "../../../../context/studylist/StudylistContext";
import {
  downloadCompletedCsvFile,
  downloadCompletedExcelFile,
  exportCsvStudyApi,
  exportExcelStudyApi,
  exportCsvStudyStatusAPI,
  fetchCsvDownloadProgress,
  fetchExcelDownloadProgress,
} from "../../../../service/StudyListService";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import { ExportAdminCsvSchema, ExportCsvSchema } from "../../../../Schemas/ExportCsvSchema";
import userContext from "../../../../context/users/UserContext";
import { TOAST_TYPE, USERTYPES } from "../../../../constants/Constants";
import toastContext from "../../../../context/toast/ToastContext";
import { getEnv } from '../../../../helpers/EnvHelper';

const ExportCsv = (props) => {

  const { roles,firmId,email } = useContext(userContext);
  const {
    showToastv2,
    showProgressToast,
    setProgressList,
    progressList,
    updateProgress,
    hideProgress,
  } = useContext(toastContext);
  const enterprise =
    getEnv("REACT_APP_ENTERPRISE_PLATFORM") == "true" ||
    getEnv("REACT_APP_ENTERPRISE_PLATFORM") == true
      ? true
      : false;
  const [t] = useTranslation();
  const [filterObj, setFilterObj] = useState({});
  const [finalFirmList, setFinalFirmList] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const { fullClientFirmList, clientFirmList,  
    studyCsvProgress, setStudyCsvProgress,
    studyCsvProgressId, setStudyCsvProgressId,
    setCsvToken,
    setCsvFetchInterval,
    setExportType } = useContext(studylistContext);

  const successfullResponse = t("string-literals.export-csv-success");
  const { alertSuccessModal, setAlertSuccessModal } =
    useContext(studyReportContext);
  const [selectedFirm, setSelectedFirm] = useState("");
  const [selectedFirmObj, setSelectedFirmObj] = useState(null);
  const formatClientFirmList = () => {
    let mapFirmList = [];
    console.log(clientFirmList, fullClientFirmList);
    mapFirmList = enterprise ? clientFirmList : fullClientFirmList;
    console.log(mapFirmList);
    let finalClientFirmList = mapFirmList.map((firm, index) => {
      return {
        value: firm.id,
        label: firm.name,
      };
    });
    setFinalFirmList(finalClientFirmList);
  };
  const [selectedClientList, setSelectedClientList] = useState([]);
  const [selectedProviderList, setSelectedProviderList] = useState([]);
  const [selectedTabOption, setSelectedTabOption] = useState("dptk_allstudiestab");
  const [selectedDateOption, setSelectedDateOption] = useState("upload");
  const [selectedExportFormat, setSelectedExportFormat] = useState("csv");
  const [downloadRunning, setDownloadRunning] = useState(false);
  const modalBodyRef = useRef(null);
  

  const handleExportCsvStatusApi = async () => {
    const response = await exportCsvStudyStatusAPI();
    console.log("---- Response status export csv ----", response);
    if (response.status === 200 && response.data.data != "Error") {
      if (response.data.data === "Processing") {
        //props.setConfirmResponseMessage();
        //props.setShowExportCsvConfirmModal(true);
        //props.setShowConfirmModal(true);
        props.setShowExportCsvModal(false);
        setAlertSuccessModal(() => {
          const newItem = { ...alertSuccessModal };
          newItem.show = true;
          newItem.heading = "Request for Export Studies";
          newItem.isError = false;
          newItem.isSuccess = false;
          newItem.isWarning = true;
          newItem.description = t(
            "string-literals.request-in-process-export-csv"
          );
          return newItem;
        });
        
      }
      //props.setShowExportCsvModal(true);
    } else {
      //props.setConfirmResponseMessage(response.data.message);
      //props.setShowExportCsvConfirmModal(true);
      //props.setShowConfirmModal(true);

      props.setShowExportCsvModal(false);
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Error";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("string-literals.failed-message");
        return newItem;
      });
      
    }
  };

  useEffect(() => {
    console.log("inside formatClientFirmList effect");
    if(roles.length > 0 && roles[0] == USERTYPES.ADMIN){
      formatClientFirmList();
    }
    
  }, [fullClientFirmList, clientFirmList]);

  useEffect(() => {
    console.log("inside handleExportCsvStatusApi effect");
    handleExportCsvStatusApi();
  }, []);

  /*
  useEffect(() => {
    console.log("inside studyZipProgress effect"); 
    console.log(studyCsvProgress);
    if (studyCsvProgress === 0) return;
    
    if (studyCsvProgress < 100) {
      updateProgress(studyCsvProgressId, studyCsvProgress);
      const oldProgress = studyCsvProgress;
      let progress;
      const zipProgressInterval = setInterval(async () => {
        progress = await fetchCsvDownload(zipProgressInterval);
        if (progress > oldProgress) {
          clearInterval(zipProgressInterval);
        }
      }, csvFetchInterval);
    }

    if (studyCsvProgress === 100) {
      updateProgress(studyCsvProgressId, studyCsvProgress);
      downloadFile(csvToken, true);
    }

    if (studyCsvProgress === 101) {
      updateProgress(studyCsvProgressId, 100);
      setTimeout(() => {
        hideProgress(studyCsvProgressId);
        setStudyCsvProgress(0);
      }, 3000);
    }
  }, [studyCsvProgress]);

  useEffect(() => {
    console.log("inside csvToken effect");
    console.log(csvToken);
    let progress;
    if (csvToken !== "") {
      const zipProgressInterval = setInterval(async () => {
        progress = await fetchCsvDownload(zipProgressInterval);
        if (progress > 0) {
          clearInterval(zipProgressInterval);
        }
      }, csvFetchInterval);
    }
  }, [csvToken]);*/

  const hideExportCsvModal = () => {
    props.setShowExportCsvModal(false);
    setValues({
      uploadDateFrom: "",
      uploadDateTo: "",
      firm: "",
      email: "",
    });
  };

  const formatDate = (date) => {
    var currentDate = Moment(date).local().format("DD-MMM-YYYY");
    return date == "" ? "" : currentDate;
  };

  const exportCsvPayload = (values) => {
    return {
      uploadDateFrom: formatDate(filterObj.uploadDateFrom),
      uploadDateTo: formatDate(filterObj.uploadDateTo),
      firmId: roles[0] == USERTYPES.ADMIN ? selectedFirm: firmId,
      emailId: roles[0] == USERTYPES.ADMIN ? values.email: email,
      clientOrFirmIds: selectedClientList,
      providerIds: selectedProviderList,
      activeTab : selectedTabOption,
      dateType : selectedDateOption,
      exportFormat: selectedExportFormat
    };
  };

  const checkForDateNotNull = (fromDate,toDate) => {
    fromDate = filterObj.uploadDateFrom;
    toDate = filterObj.uploadDateTo;
    if((fromDate == null || fromDate == undefined || fromDate == "") || 
    (toDate == null || toDate == undefined || toDate == "")
    ){
      return true;
    }
    return false;
  }

  const checkForDateRange = (uploadDateFrom, uploadDateTo) => {
    const monthMap = {
      Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
      Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11
    };
  
    // Parse the date strings in "dd-MMM-yyyy" format
    const fromParts = uploadDateFrom.split('-');
    const toParts = uploadDateTo.split('-');
  
    const fromDay = parseInt(fromParts[0], 10);
    const fromMonth = monthMap[fromParts[1]] || 0; // Default to January
    const fromYear = parseInt(fromParts[2], 10);
    const toDay = parseInt(toParts[0], 10);
    const toMonth = monthMap[toParts[1]] || 0;
    const toYear = parseInt(toParts[2], 10);
  
    const fromDateObject = new Date(fromYear, fromMonth, fromDay);
    const toDateObject = new Date(toYear, toMonth, toDay);
  

    // Compare the Date objects
    if (fromDateObject > toDateObject) {
      return true; // UploadDateFrom is less than or equal to UploadDateTo
    } else {
      return false; // UploadDateFrom is greater than UploadDateTo
    }
  };

  const checkForOneMonthRange = (uploadDateFrom, uploadDateTo) => {
    const monthMap = {
      Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
      Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11
    };
  
    // Parse the date strings in "dd-MMM-yyyy" format
    const fromParts = uploadDateFrom.split('-');
    const toParts = uploadDateTo.split('-');
  
    const fromDay = parseInt(fromParts[0], 10);
    const fromMonth = monthMap[fromParts[1]] || 0; // Default to January
    const fromYear = parseInt(fromParts[2], 10);
    const toDay = parseInt(toParts[0], 10);
    const toMonth = monthMap[toParts[1]] || 0;
    const toYear = parseInt(toParts[2], 10);
  
    const fromDateObject = new Date(fromYear, fromMonth, fromDay);
    const toDateObject = new Date(toYear, toMonth, toDay);

    const oneDay = 24 * 60 * 60 * 1000;
    const differenceInMilliseconds = Math.abs(fromDateObject - toDateObject);

    // Convert the difference to days
    const differenceInDays = Math.round(differenceInMilliseconds / oneDay);
    
    // Check if the difference is 31 days or less
    if (differenceInDays > 45) {
      return true; 
    } else {
      return false; 
    }
  };

  const { values, errors, handleChange, handleSubmit, setValues, setErrors } = useFormik({
    initialValues: {
      uploadDateFrom: "",
      uploadDateTo: "",
      firm: null,
      email: "",
    },
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false, 
    validationSchema: roles[0] == USERTYPES.ADMIN || roles[0] == USERTYPES.FIRMADMIN || roles[0] == USERTYPES.SUPERVISOR || roles[0] == USERTYPES.FIRMTECHNICIAN || roles[0] == USERTYPES.FIRMDOCTOR ? ExportAdminCsvSchema : null,
    onSubmit: async (values, actions) => {


        let payload = exportCsvPayload(values);

        console.log(
          "--- Check for date not null ----",checkForDateNotNull(payload.uploadDateFrom,payload.uploadDateTo));
        console.log(
          "--- Check for date not valid ----",
          checkForDateRange(payload.uploadDateFrom, payload.uploadDateTo)
        );
        if(checkForDateNotNull(payload.uploadDateFrom,payload.uploadDateTo)){
          return;
        }
        if (checkForDateRange(payload.uploadDateFrom, payload.uploadDateTo)) {
          // actions.setFieldError('uploadDateTo', StringLiterals.nameEmpty);
          setErrorMessage(t("error.from-to-date-not-correct"));
          return;
        }

        if (checkForOneMonthRange(payload.uploadDateFrom, payload.uploadDateTo)) {
          // actions.setFieldError('uploadDateTo', StringLiterals.nameEmpty);
          setErrorMessage(t("error.date-difference-greater-than-31"));
          return;
        }

        if (studyCsvProgress > 0 && studyCsvProgress < 100) {
          showToastv2(TOAST_TYPE.INFO, "Your file is getting download. Please wait");
          return;
        }

        setDownloadRunning(true);

        // setExportType(selectedTabOption === 'dptk_excel' ? 'excel' : 'csv');

        console.log("--- Export CSV Payload ---", payload);
        // const response = await (selectedTabOption === 'dptk_excel' ? exportExcelStudyApi(payload) : exportCsvStudyApi(payload));
        const response = await (exportCsvStudyApi(payload));
        console.log("response->", response);
        if (response.status === 201) {
          const id = showProgressToast("Downloading file", studyCsvProgress);
          setStudyCsvProgressId(id);
          setCsvToken(response.data.data.token);
          setCsvFetchInterval(2000);
          setStudyCsvProgress(1);
          showToastv2(TOAST_TYPE.INFO, "Downloading started");
          props.setShowExportCsvModal(false);
          setDownloadRunning(false);
        }else if (response.status === 200 && response.data.data === "Success") {
          let message =
            response.data.message === "Error in Processing!"
              ? response.data.message
              : successfullResponse;
          setAlertSuccessModal(() => {
            const newItem = { ...alertSuccessModal };
            newItem.show = true;
            newItem.heading = "Alert";
            newItem.isError = false;
            newItem.isSuccess = false;
            newItem.isWarning = true;
            newItem.description =
              response.data.message === "Error in Processing!"
                ? response.data.message
                : t("string-literals.request-success-export-csv");
            return newItem;
          });
          // props.setConfirmResponseMessage(message);
          setDownloadRunning(false);
          props.setShowExportCsvModal(false);
          //props.setShowExportCsvConfirmModal(true);
          //props.setShowConfirmModal(true);
          hideProgress(studyCsvProgressId);
         
        } else {
          setErrorMessage(response.data.message);
          setDownloadRunning(false);
          // showToastv2(TOAST_TYPE.ERROR, "Failed to start downloading");
          hideProgress(studyCsvProgressId);
          //props.setShowExportCsvModal(false);
        }

        /*if (response.status === 200 && response.data.data === "Success") {
          let message =
            response.data.message === "Error in Processing!"
              ? response.data.message
              : successfullResponse;
          setAlertSuccessModal(() => {
            const newItem = { ...alertSuccessModal };
            newItem.show = true;
            newItem.heading = "Alert";
            newItem.isError = false;
            newItem.isSuccess = false;
            newItem.isWarning = true;
            newItem.description =
              response.data.message === "Error in Processing!"
                ? response.data.message
                : t("string-literals.request-success-export-csv");
            return newItem;
          });
          // props.setConfirmResponseMessage(message);
          props.setShowExportCsvModal(false);
          //props.setShowExportCsvConfirmModal(true);
          //props.setShowConfirmModal(true);
      } else {
        setErrorMessage(response.data.message);
      }*/
    },
  });

  let DefaultButtonList = [
    {
      title: t("button.cancel"),
      onclick: hideExportCsvModal,
    },
  ];

  let PrimaryButtonList = [
    {
      title: t("button.download"),
      disabled : downloadRunning,
      onclick: handleSubmit,
    },
  ];

  const modalDetails = {
    header: (
      <ModalHeader
        updatedModal={true}
        patientName={props.patientName}
        patientID={props.patientId}
        heading={t("export-csv.title")}
        handleCancel={hideExportCsvModal}
      />
    ),
    body: (
      <ExportCsvBody
        setSelectedFirm={setSelectedFirm}
        values={values}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        errors={errors}
        filterObj={filterObj}
        setFilterObj={setFilterObj}
        finalFirmList={finalFirmList}
        selectedFirm={selectedFirm}
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
        setValues={setValues}
        setErrors={setErrors}
        selectedFirmObj={selectedFirmObj}
        setSelectedFirmObj={setSelectedFirmObj}
        selectedClientList = {selectedClientList}
        setSelectedClientList = {setSelectedClientList}
        selectedProviderList={selectedProviderList}
        setSelectedProviderList={setSelectedProviderList}
        setSelectedTabOption={setSelectedTabOption}
        setSelectedDateOption={setSelectedDateOption}
        selectedDateOption={selectedDateOption}
        selectedExportFormat={selectedExportFormat}
        setSelectedExportFormat={setSelectedExportFormat}
        calloutBounds={() => modalBodyRef.current?.getBoundingClientRect()}
      />
    ),
    footer: (
      <ModalFooter
        DefaultButtonList={DefaultButtonList}
        PrimaryButtonList={PrimaryButtonList}
      />
    ),
    width: "600px",
  };
  return (
    <>
      {props.showExportCsvModal && (
        <ModalMain
          updatedModal={true}
          modalDetails={modalDetails}
          showModal={props.showExportCsvModal}
          bodyRef={modalBodyRef}
        />
      )}
    </>
  );
};

export default ExportCsv;
